module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead4-5db481e449dc235d900910299100fb39.jpg";